import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {logger} from '@refra/modules/common/utils'

export const useDeleteStaticPartDocument = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()

  return useRefraMutation({
    mutationFn: mutations.deleteStaticPartDocument,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useDeleteStaticPartDocument')
        .extras({errorDetails})
        .error('Error occurred while deleting static part document')

      spawnErrorToast(t('error.deleteStaticPartDocument'))
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['staticPartDocuments']})
      await queryClient.invalidateQueries({queryKey: ['attachedDocumentsFiles']})
      spawnSuccessToast(t('success.deleteStaticPartDocument'))
    }
  })
}
